<template>
  <div class="systemWrap">
    <div>
      <img src="./system1.png" alt="" class="width100">
    </div>
    <div class="systemWrap1">
      <indexHomeTit :desc="descList[0].desc"></indexHomeTit>
      <div class="container marginTop40">
        <ul class="row">
          <li class="col-xs-6 col-sm-3 col-md-3 text-center">
            <div class="limint">
              <img src="./system2.png" alt="" class="minwidth100">
            </div>
            <p class="marginTop40 fontSize18 bold">患者便捷使用</p>
          </li>
          <li class="col-xs-6 col-sm-3 col-md-3 text-center">
            <div class="limint">
              <img src="./system3.png" alt="" class="minwidth100">
            </div>
            <p class="marginTop40 fontSize18 bold">精准数据统计</p>
          </li>
          <li class="col-xs-6 col-sm-3 col-md-3 text-center">
            <div class="limint">
              <img src="./system4.png" alt="" class="minwidth100">
            </div>
            <p class="marginTop40 fontSize18 bold">品牌文化宣传</p>
          </li>
          <li class="col-xs-6 col-sm-3 col-md-3 text-center">
            <div class="limint">
              <img src="./system5.png" alt="" class="minwidth100">
            </div>
            <p class="marginTop40 fontSize18 bold">扁平化管理</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="systemWrap2">
      <div class="container">
        <div class="row flex align-items">
          <div class="col-xs-5 col-sm-5 col-md-5 minNone">
            <div>
              <img src="./system7.png" alt="" class="width100">
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-6  col-md-offset-1 word">
            <indexHomeTit :desc="descList[1].desc" class="text-left"></indexHomeTit>
            <p>多部门统一管理，快速便捷的医生排班，大数据分析医生专长</p>
            <p>依病理推荐医生，增进医生间的协作治疗、就医服务评价</p>
            <p>解决繁琐的财务对账，一键生成财务多家门诊报表</p>
            <p>自助约诊挂号，让门诊服务成本更、更有序</p>
            <a href="tencent://message/?uin=2605568468" class="sysBtn PCsysBtn">点击咨询</a>
            <a href="tel:18500058818" class="sysBtn minSysBtn">点击咨询</a>
          </div>
        </div>
      </div>
    </div>
    <div class="systemWrap3">
      <div class="container">
        <div class="row flex align-items">
          <div class="col-xs-12 col-sm-6 col-md-6 word">
            <indexHomeTit :desc="descList[2].desc" class="text-right"></indexHomeTit>
            <p>就诊时间灵活：患者根据自身时间和专家出诊时间灵活安排就诊计划</p>
            <p>挂号形式多样：现金、微信、支付宝、刷卡等灵活支付方式</p>
            <p>简化就医流程：更多的工作交给自助机去处理，减少医患沟通障碍</p>
            <p>诊前智慧导引：按病寻医,诊所导引,专家推荐,做到精准就医</p>
            <p>就医历史查询：身份证实名注册,就医历史信息精准指导再次就诊</p>
            <a href="tencent://message/?uin=2605568468" class="sysBtn PCsysBtn">点击咨询</a>
            <a href="tel:18500058818" class="sysBtn minSysBtn">点击咨询</a>

          </div>
          <div class="col-xs-4 col-sm-5 col-md-5  col-md-offset-1 minNone">
            <div>
              <img src="./system8.png" alt="" class="width100">
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="systemWrap2">
      <div class="container">
        <div class="row flex align-items">
          <div class="col-xs-4 col-sm-5 col-md-5 minNone">
            <div>
              <img src="./system9.png" alt="" class="width100">
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-6 word  col-md-offset-1">
            <indexHomeTit :desc="descList[3].desc" class="text-left"></indexHomeTit>
            <p>2小时内确定问题，24小时内解决问题</p>
            <p>设备定期现场检查</p>
            <p>软件系统定期升级更新</p>
            <p>系统数据持续运维服务</p>
            <p>保证系统正常运转，减轻企业运营负担</p>
            <a href="tencent://message/?uin=2605568468" class="sysBtn PCsysBtn">点击咨询</a>
            <a href="tel:18500058818" class="sysBtn minSysBtn">点击咨询</a>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
  import indexHomeTit from '../indexhometit/indexhometit.vue';
  export default {
    components: {
      indexHomeTit
    },
    data() {
      return {
         descList: [
           {'desc': '云医馆智慧中医系统'},
           {'desc': '创新的医馆管理模式'},
           {'desc': '高效便捷的就医流程'},
           {'desc': '安全稳定高效的系统'}
         ]
      }
    }
  };

</script>

<style lang="stylus" rel="stylesheet/stylus">
  .systemWrap
    .limint img
      max-width 160px
    .indexHomeTit
      background-size 500px
    .systemWrap1
      padding:140px 0
      background: url(./system6.png) center no-repeat
      .bold
        font-weight bold
    .systemWrap2,.systemWrap3
      padding:140px 0
      box-sizing: border-box;
      background: url(./system11.png) center no-repeat
      background-size cover
      .word
        font-size 18px
        .indexHomeTit
          margin-bottom 60px
          text-align left
          padding-left: 42px;
        p
          margin-bottom 35px
        .minSysBtn
          display none !important
        .sysBtn
          background: #c50000
          display inline-block
          font-size 24px
          padding 9px 50px
          color:#ffffff
          border-radius 5px
          margin-top 40px
    .systemWrap3
      background-image:url(./system10.png)
  @media (min-width: 320px) and (max-width: 750px)
    .PCsysBtn
      display none !important
    .systemWrap .systemWrap2 .word .minSysBtn,.systemWrap .systemWrap3 .word .minSysBtn
      display inline-block !important
    .minwidth100
      width 100%
    .systemWrap .indexHomeTit
      background-size 100%
    .systemWrap
      .systemWrap1
        padding: 28px 0;
        .limint
          padding 0 15px
      .minNone
        display none
      .systemWrap2,.systemWrap3
        padding: 25px 0;
        font-size 22px;
        .word
          .sysBtn
            padding: 7px 25px;
            font-size: 16px;
            width: 100%;
            text-align: center;

</style>



// WEBPACK FOOTER //
// src/components/system/system.vue